import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

export const updateCookie = (loginInfo) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};

    map[loginInfo.domain] = {
        access_key: loginInfo.access_key,
        secret_key: loginInfo.secret_key,
        timestamp: loginInfo.timestamp
    };

    Cookies.set('X-TOKEN', JSON.stringify(map), {
        expires: 10,
        path: '/',
        domain: '.grtcloud.net'
    });
};

export const clearCookie = (domain) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};

    map[domain] = null;

    Cookies.set('X-TOKEN', JSON.stringify(map), {
        expires: 10,
        path: '/',
        domain: '.grtcloud.net'
    });
};

export const objectToUrlSearchParams = (obj) => {
    let searchParams = new URLSearchParams();
    for (let key in obj) {
        searchParams.append(key, obj[key]);
    }
    return searchParams.toString();
};

export const urlSearchParamsToObject = (url) => {
    let location = new URL(url);

    let searchParams = new URLSearchParams(location.search);
    let paramsObject = {};
    for (let [key, value] of searchParams) {
        paramsObject[key] = value;
    }
    return paramsObject;
};
export const isInWeXin = () => {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    return window.navigator.userAgent.toLowerCase().includes('micromessenger');
};

/**
 * AES加密函数
 * 使用AES算法对原始文本进行加密，采用ECB模式和Pkcs7填充
 * PKCS5Padding 在 crypto-js 中对应 Pkcs7
 * @param {string} originalText - 需要加密的原始文本
 * @param {string} key - 加密密钥，需为Base64编码格式
 * @returns {string} 加密后的密文字符串
 */
export const encryptAES = (originalText, key) => {
    if (!originalText || !key) return '';
    const encrypted = CryptoJS.AES.encrypt(originalText, CryptoJS.enc.Base64.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
};

/**
 * AES解密函数
 * 使用AES算法对密文进行解密，采用ECB模式和Pkcs7填充
 * PKCS5Padding 在 crypto-js 中对应 Pkcs7
 * @param {string} encriptedText - 需要解密的密文
 * @param {string} key - 解密密钥，需为Base64编码格式
 * @returns {string} 解密后的原始文本
 */
export const decryptAES = (encriptedText, key) => {
    if (!encriptedText || !key) return '';
    const decrypted = CryptoJS.AES.decrypt(encriptedText, CryptoJS.enc.Base64.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};

export const sliceString = (str, maxLength = 12, keepLength = 6) => {
    // 先判断参数是否为字符串，避免非字符串类型报错（健壮性处理）
    if (typeof str !== 'string') {
        return '';
    }
    // 长度不超过12，直接返回原字符串
    if (str.length <= maxLength) {
        return str;
    }

    // 超过12，截取前6 + ... + 后6
    const prefix = str.slice(0, keepLength); // 截取前6位
    const suffix = str.slice(-keepLength); // 截取后6位（slice(-n) 表示从末尾倒数第n位开始截取到结尾）
    return `${prefix}....${suffix}`;
};


export const isEnaeaTenant = (tenantId) => {
    //2005474742481018881-测试环境 网院租户
    //2026570707836936193-生产环境 网院租户
    return tenantId === '2005474742481018881' || tenantId === '2026570707836936193';
};
